/**
 * Created by Allan on 2025/12/25.
 * Contact 84880528@qq.com.
 * 全局路由
 */
import Vue from 'vue'
import Router from 'vue-router'
// 导入各模块路由配置
import Login from './map/login'
import Dashboard from './map/dashboard'
import Finance from './map/finance'
import Order from './map/order'
import Product from './map/product'
import Risk from './map/risk'
import Role from './map/role'
import User from './map/user'
import Welcome from './map/welcome'

Vue.use(Router)
// 路由配置列表，注意顺序，NotFound 要定义到最后进行404的匹配拦截
// '...' es6 展开语法，所有数组展开合并成一个新的数组对象
const routes=[
    ...Welcome,
    ...Login,
    ...Dashboard,
    ...Order,
    ...User,
    ...Role,
    ...Product,
    ...Finance,
    ...Risk,
];
export default new Router({
    /*mode:'history',*/
    routes
})

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Router.prototype.replace = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js